import { PetPhoto } from '../../types/PetPhoto';

export const PHOTOS_PER_PAGE = 12;

// ToDo: Remove mock data
export const mockedPhotos: PetPhoto[] = [
  {
    id: '579838',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MM05a73076916baa01ed84eba1a9265577/Media/ME070218f6f417d3de82da3b83003db02f',
    petName: 'Mac',
    petParentName: 'Charles Reed',
    petParentId: '433657',
    createdAt: '2025-09-13 00:45:53',
    exitDate: '2025-08-20 00:00:00',
    careType: 'Adopted',
    likes: 8,
    isLikedByCurrentUser: true,
  } as PetPhoto,
  {
    id: '579814',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MMa064517e4c1f8de372417a7bd9e1cc10/Media/ME931f4c4374749732ef546b22da7b96ea',
    petName: 'Mac',
    petParentName: 'Charles Reed',
    petParentId: '433657',
    createdAt: '2025-09-12 18:49:39',
    exitDate: '2025-08-20 00:00:00',
    careType: 'Adopted',
    likes: 3,
    isLikedByCurrentUser: false,
  } as PetPhoto,
  {
    id: '579813',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MM803ebc841ff4c85950d171c6f04f9c92/Media/ME0d71d5c8cd32dff1f549b2e2dd604d07',
    petName: 'Mac',
    petParentName: 'Charles Reed',
    petParentId: '433657',
    createdAt: '2025-09-12 18:49:19',
    exitDate: '2025-08-20 00:00:00',
    careType: 'Adopted',
    likes: 12,
    isLikedByCurrentUser: false,
  } as PetPhoto,
  {
    id: '490859',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MM1ed6debd424489fc941ec62a8307bfb7/Media/MEe1e86fe6b3d1f2d762f0c158c8b14292',
    petName: 'Cinnamon Stick',
    petParentName: 'Teresa Collins',
    petParentId: '415505',
    createdAt: '2025-07-29 12:52:58',
    exitDate: '2025-07-05 00:00:00',
    careType: 'Adopted',
    likes: 5,
    isLikedByCurrentUser: true,
  } as PetPhoto,
  {
    id: '490858',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MM1ed6debd424489fc941ec62a8307bfb7/Media/ME9f0780bfd583f58b831650bce7a7897d',
    petName: 'Cinnamon Stick',
    petParentName: 'Teresa Collins',
    petParentId: '415505',
    createdAt: '2025-07-29 12:52:57',
    exitDate: '2025-07-05 00:00:00',
    careType: 'Adopted',
    likes: 0,
    isLikedByCurrentUser: false,
  } as PetPhoto,
  {
    id: '463006',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MM1f220039c7a24351e35ba9cb2c980737/Media/ME5201eda86a54a4f82e44771092c8afa0',
    petName: 'Nori',
    petParentName: 'Cain Knisley',
    petParentId: '410083',
    createdAt: '2025-07-13 12:30:46',
    exitDate: '2025-06-17 00:00:00',
    careType: 'Adopted',
    likes: 11,
    isLikedByCurrentUser: true,
  } as PetPhoto,
  {
    id: '462996',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MM708891a55f1f0d8ee37a67badd75d378/Media/MEe40c80d5deb6f3f0f3849ca7172ec90f',
    petName: 'Nori',
    petParentName: 'Cain Knisley',
    petParentId: '410083',
    createdAt: '2025-07-13 12:27:24',
    exitDate: '2025-06-17 00:00:00',
    careType: 'Adopted',
    likes: 7,
    isLikedByCurrentUser: false,
  } as PetPhoto,
  {
    id: '462985',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MMcf7535f7c3f92bf8a3fbf385141f9f0f/Media/MEf2e31c8385d0b0bae789987a7fbf0cb5',
    petName: 'Helen Roper',
    petParentName: 'Chelsea Fuller',
    petParentId: '410105',
    createdAt: '2025-07-13 12:10:29',
    exitDate: '2025-06-21 00:00:00',
    careType: 'Adopted',
    likes: 2,
    isLikedByCurrentUser: false,
  } as PetPhoto,
  {
    id: '462984',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MMcf7535f7c3f92bf8a3fbf385141f9f0f/Media/ME880eee47d856dbb56530ec3cdc3ba477',
    petName: 'Helen Roper',
    petParentName: 'Chelsea Fuller',
    petParentId: '410105',
    createdAt: '2025-07-13 12:10:28',
    exitDate: '2025-06-21 00:00:00',
    careType: 'Adopted',
    likes: 9,
    isLikedByCurrentUser: true,
  } as PetPhoto,
  {
    id: '462983',
    url: 'https://api.twilio.com/2010-04-01/Accounts/AC7985a7e064bb52e0d8b3c866e3255e54/Messages/MMcf7535f7c3f92bf8a3fbf385141f9f0f/Media/MEf42f8e5414a2f398ac6bb9adf389a2dd',
    petName: 'Helen Roper',
    petParentName: 'Chelsea Fuller',
    petParentId: '410105',
    createdAt: '2025-07-13 12:10:27',
    exitDate: '2025-06-21 00:00:00',
    careType: 'Adopted',
    likes: 4,
    isLikedByCurrentUser: false,
  } as PetPhoto,
];

// ToDo: Remove mock data - filter to simulate "my photos"
export const mockedMyPhotos: PetPhoto[] = mockedPhotos.slice(0, 3);
